
(function () {
    'use strict';

    angular
        .module('app')
        .controller('sendReportController', sendReportController);

    sendReportController.$inject = ['$scope', '$http'];
    function sendReportController($scope, $http) {

        $scope.sendConfirmation = {};
        $scope.sendConfirmation.headline = null;
        $scope.sendConfirmation.successMessage = null;
        $scope.sendConfirmation.errorMessage = null;
        $scope.showError = false;

        $scope.update = function(sendModel, reportid) {
            if (!$scope.sendreport.$valid) {
                $scope.showError = true;
                return;
            }
            $scope.showError = false;
            sendModel.reportId = reportid;
            $scope.sendReport(sendModel).then(
                function(result) {
                    $scope.sendConfirmation.headline = result.data.headline;
                    $scope.sendConfirmation.successMessage = result.data.successMessage;
                    $scope.sendConfirmation.errorMessage = result.data.errorMessage;
                },
                function(reason) {
                },
                function(error) {
                    $scope.sendConfirmation.errorMessage = result.data.errorMessage;
                    console.log(error);
                }
            );
        };
        $scope.reset = function () {
            $scope.user = angular.copy($scope.master);
        };
        $scope.reset();

        $scope.sendReport = function(sendModel) {
            return $http.post("/api/send/sendreport", sendModel, { cache: false });
        };
    }
})();


